import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.5557 3.40283C14.242 3.40283 14.8187 3.86445 14.9971 4.49365C15.0462 4.58798 15.0637 4.6912 15.0498 4.7915C15.0525 4.82831 15.0557 4.86534 15.0557 4.90283V11.0972C15.0557 11.9256 14.3841 12.5972 13.5557 12.5972H2.44434C1.61596 12.5971 0.944336 11.9256 0.944336 11.0972V4.90283C0.944339 4.86334 0.948172 4.82437 0.951172 4.78564C0.938507 4.68728 0.954039 4.58607 1.00195 4.49365C1.18017 3.86433 1.75794 3.40288 2.44434 3.40283H13.5557ZM1.94434 11.0972C1.94434 11.3733 2.16824 11.5971 2.44434 11.5972H13.5557C13.8318 11.5972 14.0557 11.3733 14.0557 11.0972V5.68506L9.58887 8.82373C9.12873 9.14718 8.57012 9.31982 8 9.31982C7.42995 9.31978 6.87122 9.14714 6.41113 8.82373L1.94434 5.68408V11.0972ZM2.44434 4.40283C2.30158 4.40286 2.17312 4.46311 2.08203 4.55908L6.98633 8.00635C7.2723 8.2073 7.62882 8.31978 8 8.31982C8.3712 8.31982 8.72767 8.20729 9.01367 8.00635L13.917 4.55908C13.8259 4.46344 13.6982 4.40283 13.5557 4.40283H2.44434Z",
		fill: "currentColor"
	})
});
export default SvgMail;
